module.exports = __webpack_public_path__ + "img/27_39.c5d4812b.png";